import React, { FC } from 'react'
import Flex from '../../Layout/Flex/Flex'

import {
  TooltipContainer,
  TooltipTextWrapper,
  TooltipText,
} from './Tooltip.styles'
import { TooltipProps } from './types'

const Tooltip: FC<TooltipProps> = props => {
  const { tooltipText, children, onClick, backgroundColor, textColor } = props
  if (props.remove || !tooltipText || (Array.isArray(tooltipText) && tooltipText?.length === 0)) {
    return (<>{children}</>)
  }

  const wrapperStyle: React.CSSProperties = {}
  if (backgroundColor) (wrapperStyle as any)['--tooltip-bg'] = backgroundColor
  if (textColor) (wrapperStyle as any)['--tooltip-text'] = textColor

  return (
    <TooltipContainer>
      {children}
      <TooltipTextWrapper
        position={props?.position}
        translateX={props?.translateX}
        translateY={props?.translateY}
        width={props?.width}
        onClick={onClick ? onClick : null}
        style={wrapperStyle}
        largeContent={props?.largeContent}
      >
        {React.isValidElement(tooltipText) ? (
          tooltipText
        ) : Array.isArray(tooltipText) ? (
          <Flex maxWidth flexDirection='column' alignItems='flex-start'>
            {tooltipText?.map((value, index) => (
              <TooltipText key={index}>{value}</TooltipText>
            ))}
          </Flex>
        ) : (
          <TooltipText>{tooltipText}</TooltipText>
        )}
      </TooltipTextWrapper>
    </TooltipContainer>
  )
}

Tooltip.defaultProps = {
  position: 'bottom',
  remove: false,
}

export default Tooltip
